import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstanceu2wrlss616lb as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/HttpStatusCode.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Send_instance1oebf6ttzyqzk as Send_instance } from './api/CommonHooks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_authority2s3hk87lssumy as get_authority } from '../../../../../ktor-ktor-http/io/ktor/http/Url.mjs';
import { get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/Logger.web.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import { takeFrom3rd40szpqy350 as takeFrom } from '../../../../../ktor-ktor-http/io/ktor/http/URLParser.mjs';
import { isSecurex1qiiavqi0xu as isSecure } from '../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { get_authorityakhc3pgcrb9j as get_authority_0 } from '../../../../../ktor-ktor-http/io/ktor/http/URLBuilder.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { Companion_getInstance29j9s2wnmk34z as Companion_getInstance_0 } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMethod.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { EventDefinition1fymk8xrdelhn as EventDefinition } from '../../../../../ktor-ktor-events/io/ktor/events/Events.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ALLOWED_FOR_REDIRECT() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return ALLOWED_FOR_REDIRECT;
}
var ALLOWED_FOR_REDIRECT;
function get_LOGGER() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return LOGGER;
}
var LOGGER;
function get_HttpResponseRedirectEvent() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return HttpResponseRedirectEvent;
}
var HttpResponseRedirectEvent;
function get_HttpRedirect() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return HttpRedirect;
}
var HttpRedirect;
var HttpRedirectConfigClass;
function HttpRedirectConfig() {
  if (HttpRedirectConfigClass === VOID) {
    class $ {
      constructor() {
        this.l5s_1 = true;
        this.m5s_1 = false;
      }
    }
    initMetadataForClass($, 'HttpRedirectConfig', HttpRedirectConfig);
    HttpRedirectConfigClass = $;
  }
  return HttpRedirectConfigClass;
}
function isRedirect(_this__u8e3s4) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var tmp0_subject = _this__u8e3s4.t57_1;
  return tmp0_subject === Companion_getInstance().b56_1.t57_1 || tmp0_subject === Companion_getInstance().c56_1.t57_1 || (tmp0_subject === Companion_getInstance().h56_1.t57_1 || (tmp0_subject === Companion_getInstance().i56_1.t57_1 || tmp0_subject === Companion_getInstance().d56_1.t57_1)) ? true : false;
}
function HttpRedirectConfig$_init_$ref_rhym9t() {
  return constructCallableReference(() => new (HttpRedirectConfig())(), 0, 0, 219, '<init>');
}
function HttpRedirect$lambda($this$createClientPlugin) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var checkHttpMethod = $this$createClientPlugin.r5p_1.l5s_1;
  var allowHttpsDowngrade = $this$createClientPlugin.r5p_1.m5s_1;
  var tmp = Send_instance;
  $this$createClientPlugin.u5p(tmp, HttpRedirect$lambda$slambda(checkHttpMethod, allowHttpsDowngrade, $this$createClientPlugin));
  return Unit_instance;
}
function *invoke$handleCall(_this__u8e3s4, context, origin, allowHttpsDowngrade, client, $completion) {
  var call = origin;
  var requestBuilder = context;
  while (true) {
    var previousProtocol = call.o5l().x5l().y58_1;
    var previousAuthority = get_authority(call.o5l().x5l());
    if (!isRedirect(call.q5j().e5m()))
      return call;
    var location = call.q5j().u54().k2q('Location');
    if (location == null) {
      get_LOGGER().p4w('Location header missing from redirect response ' + call.o5l().x5l().toString() + '; returning response as is');
      return call;
    }
    client.j5j_1.u4w(get_HttpResponseRedirectEvent(), call.q5j());
    // Inline function 'io.ktor.util.logging.trace' call
    var this_0 = get_LOGGER();
    if (get_isTraceEnabled(this_0)) {
      var tmp$ret$1 = 'Received redirect response to ' + location + ' for request ' + call.o5l().x5l().toString();
      this_0.r4w(tmp$ret$1);
    }
    // Inline function 'kotlin.apply' call
    var this_1 = new (HttpRequestBuilder())();
    this_1.p5o(requestBuilder);
    this_1.x5k_1.i58_1.y4();
    takeFrom(this_1.x5k_1, location);
    if (!allowHttpsDowngrade && isSecure(previousProtocol) && !isSecure(this_1.x5k_1.l58())) {
      // Inline function 'io.ktor.util.logging.trace' call
      var this_2 = get_LOGGER();
      if (get_isTraceEnabled(this_2)) {
        var tmp$ret$5 = 'Blocked redirect from ' + call.o5l().x5l().toString() + ' to ' + location + ' due to HTTPS downgrade';
        this_2.r4w(tmp$ret$5);
      }
      return call;
    }
    if (!(previousAuthority === get_authority_0(this_1.x5k_1))) {
      this_1.z5k_1.q4s('Authorization');
      // Inline function 'io.ktor.util.logging.trace' call
      var this_3 = get_LOGGER();
      if (get_isTraceEnabled(this_3)) {
        var tmp$ret$7 = 'Removing Authorization header for cross-authority redirect: ' + (previousAuthority + ' -> ' + this_1.x5k_1.v59());
        this_3.r4w(tmp$ret$7);
      }
    }
    requestBuilder = this_1;
    call = yield* _this__u8e3s4.y5r(requestBuilder, $completion);
  }
}
function HttpRedirect$lambda$slambda($checkHttpMethod, $allowHttpsDowngrade, $this_createClientPlugin) {
  return constructCallableReference(($this$on, request, $completion) => orPromise($completion, function *($completion) {
    var origin = yield* $this$on.y5r(request, $completion);
    var tmp;
    if ($checkHttpMethod && !get_ALLOWED_FOR_REDIRECT().t2(origin.o5l().w5l())) {
      return origin;
    }
    return yield* /*#__NOINLINE__*/invoke$handleCall($this$on, request, origin, $allowHttpsDowngrade, $this_createClientPlugin.q5p_1, $completion);
  }), 2);
}
var properties_initialized_HttpRedirect_kt_klj746;
function _init_properties_HttpRedirect_kt__ure7fo() {
  if (!properties_initialized_HttpRedirect_kt_klj746) {
    properties_initialized_HttpRedirect_kt_klj746 = true;
    ALLOWED_FOR_REDIRECT = setOf([Companion_getInstance_0().v54_1, Companion_getInstance_0().a55_1]);
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpRedirect');
    HttpResponseRedirectEvent = new (EventDefinition())();
    var tmp = HttpRedirectConfig$_init_$ref_rhym9t();
    HttpRedirect = createClientPlugin('HttpRedirect', tmp, HttpRedirect$lambda);
  }
}
//region block: exports
export {
  get_HttpRedirect as get_HttpRedirect1lgx3wewnhrb0,
};
//endregion

//# sourceMappingURL=HttpRedirect.mjs.map
